import { COUNTRY } from "../constants/countries"

// Convert a number to a string with commas
export function numberWithCommas(x: number | string, fixedDecimals?: boolean, withoutSign?: boolean) {
  const number = Number(x).toString().split('.')
  if (number[1]) {
    return (
      (!withoutSign ? COUNTRY.amountSign ?? '$' : '' ) + number[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      '.' + number[1].slice(0, 2).padEnd(2, '0') +
      (fixedDecimals ? '.00' : '')
    )
  }
  return (
    (!withoutSign ? COUNTRY.amountSign ?? '$' : '' ) + number[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
    (fixedDecimals ? '.00' : '')
  )
}

export function generateRandomInteger(max: number) {
  return (Math.floor(Math.random() * max) + 1)
}

export function generateRandomIntegerMaxMin(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function clamp(num: number, max: number) {
  return num > max ? max : num
}

export function generateRandomNumber(min: number, max: number) {
  const difference = max - min

  // generate random number
  let rand = Math.random()

  // multiply with difference
  rand = rand * difference

  // add with min value
  rand = rand + min

  return rand
}

export const AMOUNT_SIGN = COUNTRY.amountSign ?? '$'

export function formatShortAmount(amount: number | string): string {
  const num = typeof amount === "string" ? parseFloat(amount) : amount

  if (isNaN(num)) return `${AMOUNT_SIGN}0`

  if (num >= 1_000_000) {
    const value = num / 1_000_000
    const truncated = Math.floor(value * 10) / 10 // truncate to 1 decimal
    return `${AMOUNT_SIGN}${Number.isInteger(truncated) ? truncated.toFixed(0) : truncated}M`
  }

  if (num >= 1_000) {
    const value = num / 1_000
    const truncated = Math.floor(value * 10) / 10 // truncate to 1 decimal
    return `${AMOUNT_SIGN}${Number.isInteger(truncated) ? truncated.toFixed(0) : truncated}K`
  }

  return `${AMOUNT_SIGN}${num}`
}
